/**
 * Helios Fingerprint SDK
 *
 * A comprehensive browser fingerprinting solution for device identification,
 * fraud detection, and analytics.
 *
 * @example
 * ```javascript
 * // Import from CDN
 * const fpPromise = import('@mstechmalaysia/helios-fingerprint-sdk')
 *   .then((m) => m.load());
 *
 * // Get fingerprint
 * fpPromise
 *   .then(fp => fp.get())
 *   .then(result => console.log(result.visitorId));
 * ```
 *
 * @example
 * ```javascript
 * // With configuration
 * const fpPromise = import('@mstechmalaysia/helios-fingerprint-sdk')
 *   .then((m) => m.load({
 *     publicApiKey: 'YOUR_PUBLIC_API_KEY',
 *     apiEndpoint: 'https://your-custom-endpoint.com'
 *   }));
 * ```
 */

// Export main SDK functionality
export { load } from "./sdk";

// Phase 13.16 — exposed so customers can verify which build they're running.
// Also shipped in /v1/collect payloads (observations.sdk_version).
export { SDK_VERSION } from "./version";

// Export types for TypeScript users
export type {
  FingerprintConfig,
  FingerprintResult,
  FingerprintSDK,
  LoadFunction,
  BrowserFeatures,
} from "./types";

// Export error classes
export { FingerprintError, FingerprintTimeoutError, FingerprintNetworkError } from "./types";

// Export collector for advanced users
export { collectFingerprintFeatures, sendFingerprint } from "./collector";

// Default export for convenient usage
import { load } from "./sdk";
export default { load };
